<p class="prompt-link">
  {{ prompt() | translate }}&ngsp;<span class="action-group">
    @if (icon(); as name) {
      <ui-asset class="action-icon" [name]="name" />&ngsp;
    }
    <ui-button
      class="action"
      [config]="linkConfig"
      [disabled]="disabled()"
      [mkpDataTest]="dataTest()"
      [routerLink]="route()"
      (click)="linkClick.emit()"
      >{{ link() | translate }}</ui-button
    >
  </span>
</p>
